import React from 'react';

/* 공장 국기 아이콘 — 공장 사출 현황(Factory.jsx)과 전사 통합 대시보드가 함께 쓴다.
 * 공장 API 에 국가 컬럼이 없어 주소(address/location)와 공장명 키워드로 판별한다.
 * 이모지 국기는 Windows Chrome 에서 글자로 깨져 인라인 SVG 로 그린다.
 * 스타일 클래스는 호출한 화면의 접두어를 cls 로 받는다 (예: fo-flag → fo-flag fo-flag-kr). */

export const countryOfFactory = (name, address) => {
  const s = `${name || ''} ${address || ''}`.toLowerCase();
  if (/korea|한국|\bkr\b|대한민국/.test(s)) return 'KR';
  if (/viet|베트남|\bvn\b/.test(s)) return 'VN';
  return null;
};

function FactoryFlag({ country, cls = 'ff-flag', size = 22 }) {
  if (country === 'KR') {
    /* 태극 (흰 바탕, 위 빨강/아래 파랑 음양).
     * 실제 태극기처럼 축을 왼쪽 위 → 오른쪽 아래(건·곤 대각선)로 33.69° 기울이고,
     * 왼쪽은 빨강이 아래로, 오른쪽은 파랑이 위로 감겨 들게 한다. */
    return (
      <span className={`${cls} ${cls}-kr`} aria-hidden="true">
        <svg viewBox="0 0 22 22" width={size} height={size}>
          <circle cx="11" cy="11" r="11" fill="#FFFFFF" />
          <g transform="rotate(33.69 11 11)">
            <path d="M5.5 11a5.5 5.5 0 0 1 11 0z" fill="#CD2E3A" />
            <path d="M5.5 11a5.5 5.5 0 0 0 11 0z" fill="#0047A0" />
            <circle cx="8.25" cy="11" r="2.75" fill="#CD2E3A" />
            <circle cx="13.75" cy="11" r="2.75" fill="#0047A0" />
          </g>
        </svg>
      </span>
    );
  }
  if (country === 'VN') {
    return (
      <span className={`${cls} ${cls}-vn`} aria-hidden="true">
        <svg viewBox="0 0 22 22" width={size} height={size}>
          <circle cx="11" cy="11" r="11" fill="#DA251D" />
          <polygon fill="#FFCD00"
            points="11,4.2 12.9,9.1 18.1,9.1 13.9,12.1 15.5,17.1 11,14.1 6.5,17.1 8.1,12.1 3.9,9.1 9.1,9.1" />
        </svg>
      </span>
    );
  }
  return (
    <span className={`${cls} ${cls}-none`} aria-hidden="true">
      <span className="material-symbols-outlined">factory</span>
    </span>
  );
}

export default FactoryFlag;
